const defaultNingmeng = {
  siteName: '柠檬编程训练平台',
  welcomeText: '欢迎来到柠檬课堂',
  favicon: '/brands/ningmeng/favicon.ico',
  logo: '/brands/ningmeng/logo.png',
};

const defaultVavaha = {
  siteName: '零壹编程平台',
  welcomeText: '欢迎来到零壹课堂',
  favicon: '/brands/vavaha/favicon.ico',
  logo: '/brands/vavaha/logo.png',
};

// vavaha.com 子域名映射表 —— 新增子域名只需在此添加一行
const vahaSubdomainMap = {
  fangzhou: {
    siteName: '方舟编程平台',
    welcomeText: '欢迎来到方舟课堂',
    favicon: '/brands/fangzhou/favicon.ico',
    logo: '/brands/fangzhou/logo.png',
  },
};

function resolveBrand() {
  const hostname = window.location.hostname;

  if (hostname.indexOf('vavaha.com') < 0) {
    return defaultNingmeng;
  }

  const parts = hostname.split('.');
  const prefix = parts.length >= 3 && parts[0] !== 'www' && parts[0] !== 'g'
    ? parts[0]
    : null;

  if (prefix && vahaSubdomainMap[prefix]) {
    return { ...defaultVavaha, ...vahaSubdomainMap[prefix] };
  }

  return defaultVavaha;
}

const Brand = resolveBrand();
export default Brand;
